import {create} from "zustand";

export const useCurrentSection = create((set) => ({
    currentSection: 0,
    setCurrentSection: (value) => set(({currentSection: value})),
}))
